const _ = require('underscore');

module.exports = {}

/**
 * Evaluates the given argument and returns true if it evaluates to true in the boolean sense.
 */
module.exports.isTrue = function(arg) {
    return arg === true || arg === "true";
}

/**
 * Evaluates the given argument and returns true if it evaluates to true in the boolean sense,
 * ignoring case if it is a string
 */
// module.exports.isTrueIgnoreCase = function(arg) {
module.exports.isTrueIgnoreCase = function isTrueIgnoreCase(arg) {
    if (arg === true) {
        return true;
    }

    if (!isEmpty(arg) && arg.toLowerCase !== undefined) {
        return arg.toLowerCase() === "true";
    }

    return false;
}

/**
 * Evaluates the given argument and returns true if it evaluates to false in the boolean sense.
 */
module.exports.isFalse = function(arg) {
    // If false, undefined, or null ... it's true!
    if (arg === false || arg === undefined || arg === null) {
        return true;
    }
    // If it's a string "false" it's true!
    if (typeof arg === "string") {
        return arg.toLowerCase() === "false"
    } else {
        return false;
    }
}

/**
 * Determine if the object parameter has properties. (There's a better way?).
 *
 * @param {object} o - an Object
 * @return {boolean} True if object has no properties. Otherwise, false.
 */
function isEmpty(o) {
    for (let key in o) {
        if (o.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}
module.exports.isEmpty = isEmpty;

/**
 * A simple function that returns a default ( or alternate ) value if the first parameter is empty.
 * Convenience method that helps clean up some initialization code
 *
 * @param obj
 * @param defaultObj
 * @return obj if it is not empty, otherwise defaultObj
 */
module.exports.defaultIfEmpty = function(obj, defaultObj) {

    if(isEmpty(obj)) {
        return defaultObj;
    }

    return obj;
}

/**
 * size: Return the size of an object
 */
module.exports.size = function(obj) {
    let size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
}

/**
 * Null-safe function that splits a string by a delimiter
 * Tokens between each delimiter are trimmed of leading and trailing white space.
 * Empty or blank input returns an empty array.
 *
 * @param {string} input - A string containing tokens separated by a delimiter
 * @param {string} [delimiter] - The delimiter. Defaults to comma.
 *
 * @return {string[]} an array of the separated tokens, or an empty array if the input is empty
 */
function tokenize(input, delimiter) {
    if (! delimiter) {
        delimiter = ",";
    }

    // If spaces are used as the delimiter then normalize the delimter and the input by collapsing everyting.
    if (delimiter.match(/\s+/)) {
        delimiter = " ";
        input = input.replace(/\s+/g, " ");
    }

    let results = [];

    if (!isEmpty(input) && input.trim().length > 0) {
        results = results.concat(input.split(delimiter).map( x => x.trim()));
    }

    return results;
}
module.exports.tokenize = tokenize;

/**
 * Parses a map string and returns it as an object.
 *
 * e.g. given the string "foo:bar,charlie:delta"
 * will return the json object:
 *   { "foo":"bar", "charlie":"delta" }
 *
 * The tokens used for the string are customizable, so you could split a string like: "foo=bar;alpha=bravo".
 * The defaults are comma and colon, so that the default mapString resembles a json object.
 *
 * If allowMultiple is set to true, the same key can be specified multiple
 * times for multiple values. For example, given the string:
 *   "foo:bar, foo:bravo, charlie:delta"
 * you will get a json object where object keys are a list of values:
 *   { "foo":["bar", "bravo"], "charlie":["delta"] }
 *
 *
 * @param {string} mapString - The string to split
 * @param {boolean} [allowMultiple] - Whether to allow the same key to have multiple values. Defaults to false
 * @param {string} [tokenDelimiter] - The delimiter used between key-value pairs. Defaults to comma
 * @param {string} [keyValueDelimiter] - The delimiter used to split a key and its value. Defaults to colon
 * @return {any} Typescript can't statically determine an appropriate type here, so callers are on their own.
 */
function parseMapString(mapString, allowMultiple = false, tokenDelimiter = ",", keyValueDelimiter = ":") {

    if (!_.isString(mapString)) {
        throw `Error: ${mapString} is not a string`;
    }

    let map = {};
    tokenize(mapString, tokenDelimiter)
        .forEach(pair => {
            let num_delims = (pair.match(new RegExp(keyValueDelimiter, 'g')) ?? []).length;
            if (num_delims != 1) {
                throw `Invalid key-value pair: [${pair}]`;
            }

            let [key, value] = pair.split(new RegExp(`\\s*${keyValueDelimiter}\\s*`));

            if (key == "") {
                throw `Missing key for pair: [${pair}]`;
            }
            if (value == "") {
                throw `Missing value for pair: [${pair}]`;
            }

            if (!map[key]) {
                map[key] = []
            }
            map[key].push(value);
        });

    /*
     * If multiple keys aren't allowed, convert the map values from a list of values to a single value.
     * Throw an error if multiple values were given.
     */
    if (!allowMultiple) {
        map = _.mapObject(map, (val, key) => {
            if (val.length != 1) {
                throw `Too many values for key: ${key}`
            }
            return val[0]
        });
    }

    return map;
}

module.exports.parseMapString = parseMapString;

/**
 * Pulls the hostname out of a URL.
 * @param {string} url
 * @return {string} The hostname.
 */
module.exports.extractHostname = function(url) {
    let hostname;
    // Remove protocol (http, ftp, etc.) and get hostname
    if (url.indexOf("//") > -1) {
        hostname = url.split('/')[2];
    } else {
        hostname = url.split('/')[0];
    }

    // Remove port number
    hostname = hostname.split(':')[0];
    // Remove "?"
    hostname = hostname.split('?')[0];

    return hostname;
}

/**
 * Base64 encodes the given string.
 * @param data The data to encode. Be a string or an array of bytes.
 * @returns {string} The base64 encoded string.
 */
module.exports.base64encode = data => Buffer.from(data).toString('base64');

/**
 * Decodes the given base64 value.
 * @param data The data to decode. Should be a string or an array of bytes.
 * @returns {string} The decoded string.
 */
module.exports.base64decode = data => Buffer.from(data, 'base64').toString('utf-8');

/**
 * Performs a recursive merge of the given objects. Effectively values in the props of the object in the first argument
 * are overwritten by corresponding values in subsequent object properties if they exist or are created if they don't
 * e.g. ...
 *
 * const obj = merge({a: "A", b: {c1: "C1", c2: "C2"}, x: "X"}, {a: "NewA", b: {c1: "NewC1"}, y: "Y"});
 * console.log(JSON.stringify(obj));
 *
 * {a: "NewA", b: {c1: "NewC1", c2: "C1"}, x: "X", y: "Y"}}
 *
 * Where are the shallow merge in underscore would yield ...
 *
 * {a: "NewA", b: {c1: "NewC1"}, x: "X", y: "Y"}
 *
 * @param objects Objects to merge
 * @returns {any} The merged object.
 */
const merge = (...objects) => {
    let objOut = {};

    // A recursive function to perform the merge ...
    const merger = (obj) => {
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                // Deal with nested objects ...
                if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                    objOut[prop] = merge(objOut[prop], obj[prop]);
                } else {
                    // ... or regular props ....
                    objOut[prop] = obj[prop];
                }
            }
        }
    };

    // Iterate through the objects and merge them ...
    for (let o of objects) {
        merger(o);
    }

    return objOut;
};
module.exports.merge = merge;

/**
 * Takes a string value and converts it to a boolean, object, or array if it seems like that what it represents.
 * Otherwise, leaves it as a string.
 *
 * Only simple arrays (numbers or strings are supported)
 */
const stringConvert = (value) => {
    if (! value) {
        return "";
    }

    let rVal;
    if (value.match(/^[Tt]rue$/)) {
        // Boolean true ...
        rVal = true;
    } else if (value.match(/^[Ff]alse$/)) {
        // Boolean false ...
        rVal = false;
    } else if (value.match(/^\[.*\]$/)) {
        // Arrays ...
        // Rewrite single quotes and double because parse doesn't handle single quotes in arrays ...
        value = value.replace(/'/g, "\"");
        rVal = JSON.parse(value);
    } else if (value.match(/^\{.*\}$/)) {
        // Objects ...
        rVal = JSON.parse(value);
    } else {
        // Strings ....
        rVal = value;
    }
    return rVal;
}
module.exports.stringConvert = stringConvert;

/**
 * Removes all key/value pairs whose value is undefined.
 */
module.exports.removeUndefs = function removeUndefs(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] === undefined) {
        delete obj[key];
      }
    });
    return obj;
}
